module.exports = __webpack_public_path__ + "static/media/awfext32_6049.9f96b561.ico";